import React from 'react'
import { Link } from 'react-router-dom'

import Nav from '../components/Nav'
import Footer from '../components/Footer'
import Header from '../components/Header'
import Card from '../components/Card'
import allClients, { moreWork } from '../utils/clients'

export default class Index extends React.Component {
  componentDidMount() {
    document.title = 'Sergi Miral'
  }

  render() {
    return (
      <div>
      <Nav />
      <div className="fadeInUp">
        <Header
          h1="I'm a designer & coder from BCN based in Berlin"
          h2="Currently doing mostly freelance/consultancy jobs and investing the rest of my time developing design tools & other side projects."
        >
          {/* <Link to="/contact" className="btn dark">Get in touch</Link> */}
        </Header>
        <section className="container">
          <h3 className="col-1-of-1 headline">> featured_projects:</h3>
        </section>
        <section className="container clients">
          {allClients.map(client => {
            const className = {
              className: client.properties !== null
                ? ['card', client.properties.className].join(' ')
                : 'card',
            }
            const size = client.properties !== null ? 'large' : 'small'
            return (
              <Card
                client={client}
                className={className}
                size={size}
                key={client.order}
              />
            )
          })}
        </section>
        {/* <div className="container morework">
          <h3 className="col-1-of-1 headline">> other_stuff:</h3>
          <section className="grid-row">
            {moreWork.map(work =>
              <a
                href={work.href}
                target="_blank"
                rel="noopener noreferrer"
                className="col-3-of-12"
                key={work.img}
              >
                <img
                  src={require(`img/more/${work.img}.png`)}
                  alt={work.href}
                />
              </a>
            )}
          </section>
        </div> */}
      </div>
      <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/javascripts/pages/Home.js